module.exports = __webpack_public_path__ + "img/photo-post.9a8577ba.png";